import {
  SetterMethods as RewardVaultSetterMethods,
  SetStakingToken as rewardVaultSetStakingToken,
  SetRewardToken as rewardVaultSetRewardToken,
  SetRewardFeeder as rewardVaultSetRewardFeeder,
  SetClaimWhitelist as rewardVaultSetClaimWhitelist,
  RevokeClaimWhitelist as rewardVaultRevokeClaimWhitelist,
} from "./setters";
import {
  GetterMethods as RewardVaultViewMethods,
  GetRewardFeeder as rewardVaultGetRewardFeeder,
  GetRewardToken as rewardVaultGetRewardToken,
  GetStakingToken as rewardVaultGetStakingToken,
  GetUserClaimData as rewardVaultGetUserClaimData,
  GetVaultData as rewardVaultGetVaultData,
} from "./getters";
import {
  UserMethods as RewardVaultUserMethods,
  Claim as rewardVaultClaim,
} from "./user";
import { 
  FunderMethods as RewardVaultFunderMethods,
  FundVault as rewardVaultFundVault,
  CachebackVault as rewardVaultCachebackVault,
} from "./funder";
import {
  PauserMethods as RewardVaultPauserMethods,
  StartDistributing as rewardVaultStartDistributing,
  StopDistributing as rewardVaultStopDistributing,
} from "./pauser";

const NamedSetterMethods = {
  rewardVaultSetStakingToken,
  rewardVaultSetRewardToken,
  rewardVaultSetRewardFeeder,
  rewardVaultSetClaimWhitelist,
  rewardVaultRevokeClaimWhitelist,
};
const NamedUserMethods = {
  rewardVaultClaim,
};

const NamedViewMethods = {
  rewardVaultGetRewardFeeder,
  rewardVaultGetRewardToken,
  rewardVaultGetStakingToken,
  rewardVaultGetUserClaimData,
  rewardVaultGetVaultData,
};

const NamedFunderMethods = {
  rewardVaultFundVault,
  rewardVaultCachebackVault,
};

const NamedPauserMethods = {
  rewardVaultStartDistributing,
  rewardVaultStopDistributing,
};

export const RewardVaultMethods = {
  ...NamedViewMethods,
  ...NamedUserMethods,
  ...NamedSetterMethods,
  ...NamedFunderMethods,
  ...NamedPauserMethods,
};
export { 
  RewardVaultSetterMethods,
  RewardVaultViewMethods,
  RewardVaultUserMethods,
  RewardVaultFunderMethods,
  RewardVaultPauserMethods,
};
export default RewardVaultMethods;
